import {Dameleon} from "@view/Dameleon";
import './css/main.css';

function isWebGLAvailable() {
    try {
        var canvas = document.createElement('canvas');
        return !!(window.WebGLRenderingContext &&
            (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
    } catch (e) {
        return false;
    }
}

if (!isWebGLAvailable()) {
    document.getElementById('no-webgl').style.display = 'flex';
}

new Dameleon();